import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'geoLayersUpload',
    path: '/geo-layers-upload',
    component: () => import('../pages/GeoLayersUploadPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
